import { TableCell } from 'ui/tableCell';
import type { EnabledAccountsColumnData } from './types';

export const COLUMNS: EnabledAccountsColumnData[] = [
  {
    name: 'Email',
    align: 'flex-start',
    value: 'userId',
    RowCell: ({ row }) => <TableCell>{row.userId}</TableCell>,
  },
  {
    name: 'Project ID',
    align: 'flex-start',
    value: 'projectId',
    RowCell: ({ row }) => <TableCell>{row.projectId}</TableCell>,
  },
  {
    name: 'Project name',
    align: 'flex-start',
    value: 'projectName',
    RowCell: ({ row }) => <TableCell>{row.projectName}</TableCell>,
  },
];
